import { render, staticRenderFns } from "./EditCommunityManagement.vue?vue&type=template&id=655ddc34&scoped=true"
import script from "./EditCommunityManagement.vue?vue&type=script&lang=js"
export * from "./EditCommunityManagement.vue?vue&type=script&lang=js"
import style0 from "./EditCommunityManagement.vue?vue&type=style&index=0&id=655ddc34&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "655ddc34",
  null
  
)

export default component.exports